import { useApplicationConfigStore } from '~/store/application-config'

export default defineNuxtRouteMiddleware(async (to) => {
  const applicationConfigStore = useApplicationConfigStore()
  const { exp } = to.query
  const strategy = exp ?? 'resumeProgress'
  const resumeUrl = await applicationConfigStore.getResumeApplicationData(strategy);
  return navigateTo(resumeUrl)
})
